<template>

<div class="page-wrap">this is profile component</div>

</template>

<script>

export default {
    name: 'profile'
}

</script>

<style lang="scss" scoped>

$red: orange;

.test {
    color: $red
}

</style>



// WEBPACK FOOTER //
// index.vue?1e1d9ffe